
import {
  computed,
  defineComponent,
  PropType,
  ref,
  reactive,
  toRefs
} from 'vue'

import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import ListHeader from '@/components/ListHeader.vue'
import { Entry, EntryConfig, RequestHandler } from '@Protium/vue-ozone-utils'
import { Address } from '@/models/generics'
import { useQuasar } from 'quasar'
import { isUUID } from '@/utils'
import { ItemViewMode } from '@/constants'
import { countryNameToISO } from '@/utils/address'

enum AddressDisplayName {
  fullname = 'Name',
  firstname = 'First Name',
  lastname = 'Last Name',
  phone = 'Phone Number',
  email = 'Email',
  street = 'Street',
  streetNumber = 'Street Number',
  addition = 'Addition',
  zipcode = 'Zipcode',
  city = 'City',
  country = 'Country',
  country_iso = 'Country ISO code',
  company = 'Company Name'
}

export default defineComponent({
  name: 'AddressData',
  components: { ListHeader },
  props: {
    id: {
      type: String,
      default: () => Date.now().toString(16)
    },
    payload: {
      type: Object as PropType<Address>,
      required: true
    },
    request: {
      type: Function
    },
    showIssues: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    itemView: {
      type: Number as PropType<ItemViewMode>,
      default: ItemViewMode.Default
    }
  },
  emits: ['notify', 'update:modelValue', 'resolved'],
  setup (props, { emit }) {
    const $quasar = useQuasar()
    const $store = useStore()
    const $patch = props.request || $store.getters['Services/Directr'].patch
    const editing = ref(false)

    // TODO add address checking
    const parsedAddress = computed(() => ({
      fullname: props.payload?.fullname || '',
      firstname: props.payload?.firstname || '',
      lastname: props.payload?.lastname || '',
      email: props.payload?.email || '',
      phone: props.payload?.phone || '',
      street: props.payload?.street || '',
      street_number: props.payload?.street_number || (props.payload as unknown as any || {}).streetNumber || '',
      addition: props.payload?.addition || '',
      zipcode: props.payload?.zipcode || '',
      city: props.payload?.city || '',
      country: props.payload?.country || '',
      country_iso: props.payload?.country_iso || '',
      company: props.payload?.company || ''
      // department: props.payload?.department
    }))

    function save (field?:string) {
      if (!isUUID(props.id)) {
        console.warn(`Address Data | Could not save data, the passed "id" prop was not a valid UUID (was ${props.id})`)
        return
      }
      // console.log('saving...', props.payload, parsedAddress)

      $patch(props.id, { shipping_address: parsedAddress.value }).then(({ items: [updated] }) => {
        // console.log('updated', updated)
        emit('update:modelValue', parsedAddress.value)

        editing.value = false
        $quasar.notify({
          message: 'Address updated',
          type: 'positive',
          classes: 'custom-notify success',
        })
      }).catch(e => {
        console.error('Address Data | error during status update request:', e)
      })
    }

    return {
      save,
      editing,
      AddressDisplayName,
      parsedAddress,
      countryNameToISO
    }
  }
})
